//Check if the file has an image extension
export const checkImage = function (url) {
  if (url) {
    return url.match(/\.(jpeg|jpg|gif|png|bmp)/) != null;
  } else {
    return true;
  }
};
export const checkAudio = function (url) {
  if (url) {
    return url.match(/\.(mp3|wav|ogg|aac|m4a|flac)/) != null;
  } else {
    return true;
  }
};

export const checkVideo = function (url) {
  if (url) {
    return url.match(/\.(mp4|webm|ogg|avi|mov|wmv|flv)/) !== null;
  } else {
    return false;
  }
};

export const checkGlb = function (url) {
  if (url) {
    return url.match(/\.(glb)/) || url.match(/\.(fbx)/) != null;
  } else {
    return false;
  }
};

export const getModelFileType = function (url) {
  if (url.match(/\.(glb)/)) {
    return "GLB";
  }
  if (url.match(/\.(fbx)/)) {
    return "FBX";
  }
};

export const getNumberWithSuffix = (number) => {
  if (typeof number !== "number") return number; // Ensure input is a number

  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  // Special case for 11, 12, 13
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${number}th`;
  }

  // Determine suffix based on last digit
  switch (lastDigit) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};

export const trackablesList = [
  {
    value: 12,
    title: "Asset",
  },
  {
    value: 18,
    title: "Asset Version",
  },
  {
    value: 30,
    title: "Episode",
  },
  {
    value: 13,
    title: "Sequence",
  },
  {
    value: 14,
    title: "Shot",
  },
  {
    value: 17,
    title: "Shot Version",
  },
  {
    value: 10,
    title: "Task",
  },
];
